import { render, staticRenderFns } from "./msgDetailMod.vue?vue&type=template&id=c79cea6a&scoped=true&"
import script from "./msgDetailMod.vue?vue&type=script&lang=js&"
export * from "./msgDetailMod.vue?vue&type=script&lang=js&"
import style0 from "./msgDetailMod.vue?vue&type=style&index=0&id=c79cea6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79cea6a",
  null
  
)

export default component.exports